export default __webpack_public_path__ + "static/media/1.6270a0c8.png";